import Router from 'vue-router';
import Vue from 'vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VueRouteMiddleware from 'vue-route-middleware';
import menu_permission from './middleware/menu_permission';

import AdminRoutes from './components/allroutes/admin';
import SellerRoutes from './components/allroutes/seller';
import FrontRoutes from './components/allroutes/front';
import TrainingRoutes from './components/allroutes/training';
import notfound from './components/allroutes/notfound';

import clientRoute from './components/pages/routers/clientRoutes';
import freelancerRoute from './components/pages/routers/freelancerRouters';
import trainerRoute from './components/pages/routers/trainerRouters';
import studentRoute from './components/pages/routers/studentRoutes';
import twoRoleRoutes from './components/allroutes/twoRoleRoutes';
import {
  appLoginUrl,
  appSignupUrl,
  shouldUseExternalAppAuth,
} from './components/twoRole/config/appLinks';

Vue.use(Router);
Vue.use(Loading, {
  canCancel: false,
  opacity: 0.5,
  zIndex: 999,
  color: '#007BFF',
});
var allRoutes = [];
allRoutes = allRoutes.concat(
  twoRoleRoutes,
  studentRoute,
  trainerRoute,
  clientRoute,
  freelancerRoute,
  AdminRoutes,
  SellerRoutes,
  FrontRoutes,
  TrainingRoutes,
  notfound
);
let loader;
const routes = allRoutes;
let router = new Router({
  scrollBehavior(to, from, savedPosition) {
    const position = {
      x: 0,
      y: 0,
    };
    return new Promise(resolve => {
      this.app.$root.$once('scrollBeforeEnter', () => {
        resolve(position);
      });
    });
  },
  mode: 'history',
  routes,
});
router.beforeEach((to, from, next) => {
  const perms = typeof window !== 'undefined' ? window.Permissions : null;
  const isGuestAdminShell =
    typeof document !== 'undefined' &&
    document.body.classList.contains('admin-us') &&
    Array.isArray(perms) &&
    perms.length === 0;

  // Guests only see the Microsoft login shell — never /admin/denied or other admin routes.
  if (isGuestAdminShell && to.path.startsWith('/admin')) {
    if (to.path === '/admin' || to.path === '/admin/') {
      return next();
    }
    return next({ path: '/admin', replace: true });
  }

  const authPaths = [
    '/login',
    '/accountlogin',
    '/signup',
    '/signup/intent',
    '/account/register',
    '/accountregister',
  ];
  if (authPaths.includes(to.path)) {
    const targetUrl =
      to.path === '/login' || to.path === '/accountlogin' ? appLoginUrl() : appSignupUrl();

    if (shouldUseExternalAppAuth(targetUrl)) {
      window.location.assign(targetUrl);
      return next(false);
    }
  }

  return next();
});

router.beforeEach(VueRouteMiddleware({ menu_permission }));

router.beforeEach((to, from, next) => {
  //loader = Vue.$loading.show()
  //console.log("ac");
  return next();
});
router.afterEach((to, from) => {
  //loader.hide();
  window.scrollTo(0, 0);
});

/*router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.isLoggedIn) {
            next()
            return
        }
        else
            next('/admin/login')
    } else {
        next()
    }
})*/
export default router;
